import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './not-found/not-found.component';

const routes: Routes = [
  { path: "", redirectTo: "main", pathMatch: "full" },
  { path: 'main', loadChildren: () => import('./main-v1/main-v1.module').then(m => m.MainV1Module) },
  { path: "not-found", component: NotFoundComponent },
  { path: 'register', loadChildren: () => import('./customer-journey/customer-journey.module').then(m => m.CustomerJourneyModule) },
  { path: 'payment-info', loadChildren: () => import('./payment-info-module/payment-info-module.module').then(m => m.PaymentInfoModuleModule)},
  { path: "**", redirectTo: "not-found" }];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
